import { Routes, Route } from "react-router-dom";

import WIP from './pages/WIP';
import './style/main.scss';

import Login from "./pages/Login";
import Home from './pages/Home';

import RawList from './pages/Raw/RawList';

// New Raw Imports
import CreateRaw from './pages/Raw/CreateRaw';
import ViewRaw from './pages/Raw/ViewRaw';
import RawStockIn from './pages/Raw/RawStockIn';
import RawStockOut from './pages/Raw/RawStockOut';
import ViewVendor from './pages/Master/ViewVendor';
import CreateVendor from './pages/Master/CreateVendor';
import ViewCustomer from './pages/Master/ViewCustomer';
import CreateCustomer from './pages/Master/CreateCustomer';
import ViewFinished from './pages/Finished/ViewFinished';
import FinishedStockOut from './pages/Finished/FinishedStockOut';
import FinishedStockIn from './pages/Finished/FinishedStockIn';
import ViewMachine from './pages/Machine/ViewMachine';
import MachineStockOut from './pages/Machine/MachineStockOut';
import ViewBatch from './pages/Machine/ViewBatch';

function App() {
  return (
    <div className="App">
      <Routes>
        {/* Default 404 route */}
        <Route path="*" element={<WIP />} />
        {/* Login route */}
        <Route path="/" element={<Login />} />

        <Route path ="/home" element={<Home />} />
        
        
        
        {/* Raw product routes */}
        <Route path="/RawList" element={<RawList />} />
        <Route path="/CreateRaw" element={<CreateRaw />} />
        <Route path="/ViewRaw" element={<ViewRaw />} />
        <Route path="/RawStockIn" element={<RawStockIn />} />
        <Route path="/RawStockOut" element={<RawStockOut />} />
        <Route path="/ViewVendor" element={<ViewVendor />} />
        <Route path="/ViewCustomer" element={<ViewCustomer />} />
        <Route path="/CreateVendor" element={<CreateVendor />} />
        <Route path="/CreateCustomer" element={<CreateCustomer />} />
        <Route path="/ViewFinished" element={<ViewFinished />} />
        <Route path="/FinishedStockOut" element={<FinishedStockOut />} />
        <Route path="/FinishedStockIn" element={<FinishedStockIn />} />
        <Route path="/ViewMachine" element={<ViewMachine />} />
        <Route path="/MachineStockOut" element={<MachineStockOut />} />
        <Route path="/ViewBatch" element={<ViewBatch />} />

      </Routes>
    </div>
  );
}

export default App;
